module.exports = __webpack_public_path__ + "static/media/phone-whatWeDo.cb40f1d0.mp4";